import Signals from '../../signals/Signals';
import getPontoInfo from '../../requests/bank/getPontoSettings';

export default class GetPontoIntegrationSettingsCommand {
	constructor() {
		this.then = this.then.bind(this);
		this.catch = this.catch.bind(this);
		this.companyId = null;
	}

	execute(companyId) {
		this.companyId = companyId;
		return getPontoInfo(companyId).then(this.then).catch(this.catch);
	}

	then(response) {
		return response;
	}

	catch(error) {
		Signals.HideModal.dispatch();
		Signals.Error.dispatch(error);
	}
}
